import { Button } from '@bp/ui-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ImportModeChooser.module.scss';

export type ImportMode = 'import' | 'connect';

type ImportModeChooserProps = {
  onChoose: (mode: ImportMode) => void;
};

export const ImportModeChooser: FC<ImportModeChooserProps> = ({ onChoose }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.chooser}>
        <div className={styles.option}>
          <div className={styles['option-title']}>{t('lesson.importModal.options.connect.title')}</div>
          <div className={styles['option-description']}>{t('lesson.importModal.options.connect.description')}</div>
          <Button hierarchy='primary' className={styles['option-button']} onClick={() => onChoose('connect')}>
            {t('lesson.importModal.options.connect.button')}
          </Button>
        </div>
        <div className={styles.option}>
          <div className={styles['option-title']}>{t('lesson.importModal.options.import.title')}</div>
          <div className={styles['option-description']}>{t('lesson.importModal.options.import.description')}</div>
          <Button hierarchy='primary' className={styles['option-button']} onClick={() => onChoose('import')}>
            {t('lesson.importModal.options.import.button')}
          </Button>
        </div>
      </div>
    </div>
  );
};
